<template>
  <input
    :class="
      isChecked
        ? 'border-theme-secondary'
        : 'border-AkGreyscaleMediumLtGrey'
    "
    class="radio-color h-4 w-4 rounded-full bg-AkWhite border appearance-none md:h-6 md:w-6 md:checked:border-2"
    type="radio"
    :checked="isChecked"
    :value="value"
    v-bind="$attrs"
    v-on="inputListeners"
  />
</template>

<script>
export default {
  name: 'RadioColor',
  props: ['checked', 'value'],
  model: {
    prop: 'checked',
    event: 'input'
  },
  computed: {
    isChecked () {
      return this.checked === this.value
    },
    inputListeners: function () {
      return {
        ...this.$listeners,
        input: () => {
          // ;(this.$emit as Function)('input', event.target.value)
          this.$emit('input', this.value)
        },
        // for Microsoft Edge
        change: () => {
          // ;(this.$emit as Function)('input', event.target.value)
          this.$emit('input', this.value)
        }
      }
    }
  }
}
</script>

<style lang="stylus">
$themes = {
  familles: '%2357c2dc',
  enseignants: '%2386d1c3',
  institutionnel: '%23ff7f7c',
  partenaires: '%23e15c95',
  musique: '%23bd8fd5',
  rh: '%23ff7f7c'
}

[class^='radio-color']:checked
  background-image url("data:image/svg+xml,%3csvg viewBox='0 0 64 64' fill='%2357c2dc' xmlns='http://www.w3.org/2000/svg' %3e%3ccircle cx='32' cy='32' r='20'/%3e%3c/svg%3e")

for $index, $value in $themes
  .theme-{$index} [class^='radio-color']:checked
    background-image url("data:image/svg+xml,%3csvg viewBox='0 0 64 64' fill='" + $value + "' xmlns='http://www.w3.org/2000/svg' %3e%3ccircle cx='32' cy='32' r='20'/%3e%3c/svg%3e")
</style>
